import { useCallback, useRef, useState } from 'react';

export const useOpen = (defaultOpen = false) => {
  const [open, setOpen] = useState(defaultOpen);

  const onOpen = useCallback(() => setOpen(true), []);
  const onClose = useCallback(() => setOpen(false), []);
  const onToggle = useCallback(() => setOpen((v) => !v), []);

  const container = useRef({
    setOpen,
    onOpen,
    onClose,
    onToggle,
  });

  return Object.assign(container.current, { open });
};
